import { EnumColor } from '@40seas/frontend/common/providers';
import { HttpStatusCode } from '@40seas/entities/common';

export const httpStatusColorMapping = {
    [HttpStatusCode.Continue]: 'info',
    [HttpStatusCode.SwitchingProtocols]: 'info',
    [HttpStatusCode.Processing]: 'info',
    [HttpStatusCode.EarlyHints]: 'info',
    [HttpStatusCode.OK]: 'success',
    [HttpStatusCode.Created]: 'success',
    [HttpStatusCode.Accepted]: 'success',
    [HttpStatusCode.NonAuthoritativeInformation]: 'info',
    [HttpStatusCode.NoContent]: 'success',
    [HttpStatusCode.ResetContent]: 'info',
    [HttpStatusCode.PartialContent]: 'info',
    [HttpStatusCode.MultiStatus]: 'info',
    [HttpStatusCode.AlreadyReported]: 'info',
    [HttpStatusCode.IMUsed]: 'info',
    [HttpStatusCode.MultipleChoices]: 'default',
    [HttpStatusCode.MovedPermanently]: 'default',
    [HttpStatusCode.Found]: 'default',
    [HttpStatusCode.SeeOther]: 'default',
    [HttpStatusCode.NotModified]: 'default',
    [HttpStatusCode.UseProxy]: 'default',
    [HttpStatusCode.SwitchProxy]: 'default',
    [HttpStatusCode.TemporaryRedirect]: 'default',
    [HttpStatusCode.PermanentRedirect]: 'default',
    [HttpStatusCode.BadRequest]: 'error',
    [HttpStatusCode.Unauthorized]: 'error',
    [HttpStatusCode.PaymentRequired]: 'error',
    [HttpStatusCode.Forbidden]: 'error',
    [HttpStatusCode.NotFound]: 'error',
    [HttpStatusCode.MethodNotAllowed]: 'error',
    [HttpStatusCode.NotAcceptable]: 'error',
    [HttpStatusCode.ProxyAuthenticationRequired]: 'error',
    [HttpStatusCode.RequestTimeout]: 'error',
    [HttpStatusCode.Conflict]: 'error',
    [HttpStatusCode.Gone]: 'error',
    [HttpStatusCode.LengthRequired]: 'error',
    [HttpStatusCode.PreconditionFailed]: 'error',
    [HttpStatusCode.PayloadTooLarge]: 'error',
    [HttpStatusCode.URITooLong]: 'error',
    [HttpStatusCode.UnsupportedMediaType]: 'error',
    [HttpStatusCode.RangeNotSatisfiable]: 'error',
    [HttpStatusCode.ExpectationFailed]: 'error',
    [HttpStatusCode.ImATeapot]: 'error',
    [HttpStatusCode.MisdirectedRequest]: 'error',
    [HttpStatusCode.UnprocessableEntity]: 'error',
    [HttpStatusCode.Locked]: 'error',
    [HttpStatusCode.FailedDependency]: 'error',
    [HttpStatusCode.TooEarly]: 'error',
    [HttpStatusCode.UpgradeRequired]: 'error',
    [HttpStatusCode.PreconditionRequired]: 'error',
    [HttpStatusCode.TooManyRequests]: 'error',
    [HttpStatusCode.RequestHeaderFieldsTooLarge]: 'error',
    [HttpStatusCode.UnavailableForLegalReasons]: 'error',
    [HttpStatusCode.InternalServerError]: 'error',
    [HttpStatusCode.NotImplemented]: 'error',
    [HttpStatusCode.BadGateway]: 'error',
    [HttpStatusCode.ServiceUnavailable]: 'error',
    [HttpStatusCode.GatewayTimeout]: 'error',
    [HttpStatusCode.HTTPVersionNotSupported]: 'error',
    [HttpStatusCode.VariantAlsoNegotiates]: 'error',
    [HttpStatusCode.InsufficientStorage]: 'error',
    [HttpStatusCode.LoopDetected]: 'error',
    [HttpStatusCode.NotExtended]: 'error',
    [HttpStatusCode.NetworkAuthenticationRequired]: 'error',
} as { [key in HttpStatusCode]: EnumColor };
